// extracted by mini-css-extract-plugin
module.exports = {"constraint":"+wmOr","label":"XRUXI","inputs":"HvSnK","input":"ONOi-","value":"OZGjd","delete":"Zesvn"};